module.exports = __webpack_public_path__ + "static/img/19.01d4cb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/19.png
// module id = z0e0
// module chunks = 0